import { FilterParams } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { useFilter } from '@synergy/components';

import { Account } from '../../models/account';
import { PoolAccountAutocompleteList } from '../autocomplete-list/account-autocomplete-list/pool-account-autocomplete-list';

export const RecipientAccountFilter = () => {
    const { filter, getFromCache, updateCache, updateFilter, registerFilterMap } = useFilter();

    const onSelected = (account: Account | null) => {
        filter.delete(FilterParams.RecipientAccountId);
        if (account) {
            updateCache(`account_${account.id}`, account.name);
            filter.set(FilterParams.RecipientAccountId, account.id.toString());
        }
        updateFilter(filter);
    };

    const getDisplayValue = (accountId: unknown): string => {
        if (typeof accountId !== 'string') {
            return '';
        }

        return getFromCache(`account_${accountId}`) as string;
    };

    registerFilterMap(FilterParams.RecipientAccountId, getDisplayValue);

    return (
        <PoolAccountAutocompleteList
            onSelected={onSelected}
            label={<FormattedMessage id="app.label.recipient" />}
            required={false}
            initialValue={getDisplayValue(filter.get(FilterParams.RecipientAccountId)) ?? ''}
            disablePreventOverflow={true}
        />
    );
};
